import { SortingRule } from "react-table";
import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchOfficeRequest = () =>
  GET("user/ou").pipe(map((response: any) => response));

export const fetchUserRequest = (id: string | number) =>
  GET(`user/managedUser?ou=${id}`).pipe(map((response: any) => response));

export const fetchOfficeEntitlementRequest = (id: string | number) =>
  GET(`entitlements?ou=${id}`).pipe(map((response: any) => response));

export const fetchEntitlementRequest = (
  selectedUsers: any[],
  fetchBusinessRole: boolean = true
) =>
  POST(
    `entitlements/searchByUserId${
      fetchBusinessRole ? "?businessRole=true" : ""
    }`,
    selectedUsers
  ).pipe(map((response: any) => response));

export const fetchCreateRequest = (abilitationObj: FormData) =>
  POST(
    "request/createRequests",
    abilitationObj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchBAOEntitlementRequest = (id: string | number) =>
  GET(`entitlements/businessRole?ou=${id}`).pipe(
    map((response: any) => response)
  );

export const getPaginatedEntitlementRequestService = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    entitlementName?: string;
    entitlementDescription?: string;
    applicationName?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy?: SortingRule<{}>[];
}) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/userCodes/commonOus${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ``
    }`,
    body
  ).pipe(map((response: any) => response));
};

export const getPaginatedBusinessRoleRequestService = (payload: {
  body: {
    userCodes: string[];
    ou?: string;
    application?: string;
    applicationDescription?: string;
    pageNumber: number;
    pageSize: number;
  };
  sortBy?: SortingRule<{}>[];
}) => {
  const { body, sortBy } = payload;
  return POST(
    `entitlements/commonBusinessRolesByUsers${
      sortBy && sortBy.length > 0
        ? `?sortField=${sortBy[0].id}&sortOrder=${
            sortBy[0].desc ? "desc" : "asc"
          }`
        : ``
    }`,
    body
  ).pipe(map((response: any) => response));
};
